export default "__VITE_ASSET__CaiMe9Cu__"